'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _Morningstar = require('./Morningstar.css');

var _Morningstar2 = _interopRequireDefault(_Morningstar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Morningstar = (_dec = (0, _reactCssModules2.default)(_Morningstar2.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(Morningstar, _Component);

  function Morningstar(props) {
    (0, _classCallCheck3.default)(this, Morningstar);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Morningstar.__proto__ || (0, _getPrototypeOf2.default)(Morningstar)).call(this, props));

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(Morningstar, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var title = 'Morningstar';
      var description = 'Get your money out of fossil fuels. Morningstar, Inc. provides data and investment research to Fossil Free Funds.';
      var url = _config2.default.domain + '/morningstar';

      // const coalicon = require( '../../../static/images/FFF_website_10_assets_about_industriesicons_coal.png' )
      // const oilgasicon = require( '../../../static/images/FFF_website_10_assets_about_industriesicons_oilgas.png' )
      // const utilityicon = require( '../../../static/images/FFF_website_10_assets_about_industriesicons_utilities.png' )

      var iconCo = require('../../../static/images/icn-co.svg');
      var iconOg = require('../../../static/images/icn-og.svg');
      var iconUt = require('../../../static/images/icn-ut.svg');

      return _react2.default.createElement(
        'div',
        null,
        _container2.default.helmet(title, description, url),
        _react2.default.createElement(
          'div',
          { styleName: 'page' },
          _react2.default.createElement(
            'div',
            { styleName: 'container' },
            _react2.default.createElement(
              'div',
              { styleName: 'container-inner' },
              _react2.default.createElement(
                'div',
                { styleName: 'title' },
                title
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'x-morningstar-wrap' },
            _react2.default.createElement(
              'div',
              { styleName: 'x-morningstar-container' },
              _react2.default.createElement(
                'div',
                { styleName: 'x-morningstar-container-inner' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'x-morningstar-info-photo' },
                  _react2.default.createElement('div', {
                    styleName: 'x-morningstar-photo',
                    title: 'Morningstar'
                  }),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'x-morningstar-info' },
                    _react2.default.createElement(
                      'p',
                      null,
                      'Morningstar, Inc. provides data and investment research to Fossil Free Funds. Morningstar has data on thousands of investment offerings, including U.S. stocks and mutual funds, some of the most common investments held in 401(k)s, 403(b)s, and other retirement plans.'
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      'We use Morningstar\u2019s Global Equity Classification Structure to map companies to industries, so we can track which ones are involved in fossil fuel operations.'
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.links.morningstar,
                          xstrong: true,
                          title: 'Morningstar'
                        },
                        'Visit Morningstar to learn more',
                        _react2.default.createElement(_components.LinkIcon, null)
                      )
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(_components.GetStartedInput, null),
          _react2.default.createElement(
            'div',
            { styleName: 'bullets-container' },
            _react2.default.createElement(
              'div',
              { styleName: 'bullets-container-inner' },
              _react2.default.createElement(
                'div',
                { styleName: 'title' },
                'Fossil fuel industries'
              ),
              _react2.default.createElement(
                'p',
                null,
                'The 13 Morningstar industries considered fossil fuel and screened by Fossil Free Funds are combined into three overall categories: coal, oil/gas, and fossil-fired utilities. The industries within these three categories include:'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'industry-icon-wrap' },
                _react2.default.createElement('img', {
                  styleName: 'industry-icon',
                  alt: 'Coal',
                  src: iconCo
                }),
                _react2.default.createElement(
                  'div',
                  { styleName: 'industry-icon-label-co' },
                  'Coal'
                )
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'industry-icon-bullet' },
                _react2.default.createElement(
                  'strong',
                  null,
                  'Coking Coal:'
                ),
                ' Companies that produce coking coal.'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'industry-icon-bullet' },
                _react2.default.createElement(
                  'strong',
                  null,
                  'Thermal Coal:'
                ),
                ' Companies that mine thermal coal, which is used for generating energy.'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'industry-icon-wrap' },
                _react2.default.createElement('img', {
                  styleName: 'industry-icon',
                  alt: 'Oil/gas',
                  src: iconOg
                }),
                _react2.default.createElement(
                  'div',
                  { styleName: 'industry-icon-label-og' },
                  'Oil and gas'
                )
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'industry-icon-bullet' },
                _react2.default.createElement(
                  'strong',
                  null,
                  'Oil and Gas \u2014 Drilling:'
                ),
                ' Companies primarily engaged in the drilling for petroleum and natural gas.'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'industry-icon-bullet' },
                _react2.default.createElement(
                  'strong',
                  null,
                  'Oil and Gas \u2014 Exploration and Production:'
                ),
                ' Energy companies which are primarily engaged in oil and gas exploration and production.'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'industry-icon-bullet' },
                _react2.default.createElement(
                  'strong',
                  null,
                  'Oil and Gas \u2014 Integrated:'
                ),
                ' Major energy companies engaged in the diverse aspects of oil and gas operations, including crude oil and gas exploration, production, manufacturing, refining, marketing, and transportation.'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'industry-icon-bullet' },
                _react2.default.createElement(
                  'strong',
                  null,
                  'Oil and Gas \u2014 Midstream:'
                ),
                ' Companies that own and operate oilfield pipelines and are involved in the gathering, processing, and transportation of natural crude petroleum.'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'industry-icon-bullet' },
                _react2.default.createElement(
                  'strong',
                  null,
                  'Oil and Gas \u2014 Refining and Marketing:'
                ),
                ' Companies that refine, gather, market, and sell petroleum and petroleum products.'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'industry-icon-bullet' },
                _react2.default.createElement(
                  'strong',
                  null,
                  'Oil and Gas \u2014 Equipment and Services:'
                ),
                ' Companies that provide oilfield services and equipment for activities such as contract drilling and seismic surveys. Also includes equipment and tool rental, pumping and processing services, and inspection and contracting services.'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'industry-icon-wrap' },
                _react2.default.createElement('img', {
                  styleName: 'industry-icon',
                  alt: 'Fossil-fired utilities',
                  src: iconUt
                }),
                _react2.default.createElement(
                  'div',
                  { styleName: 'industry-icon-label-ut' },
                  'Fossil-fired utilities'
                )
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'industry-icon-bullet' },
                _react2.default.createElement(
                  'strong',
                  null,
                  'Utilities \u2014 Independent Power Producers:'
                ),
                ' Companies that own and operate merchant power generation facilities and sell electricity into retail and wholesale markets.'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'industry-icon-bullet' },
                _react2.default.createElement(
                  'strong',
                  null,
                  'Utilities \u2014 Renewable:'
                ),
                ' Companies that generate, produce, or transmit electric energy from renewable sources, including hydropower, wind, geothermal, biomass, solar, tidal, and wave. (Despite the name, the Utilities-Renewable industry classification includes companies that distribute gas and/or burn fossil fuel for power generation.)'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'industry-icon-bullet' },
                _react2.default.createElement(
                  'strong',
                  null,
                  'Utilities \u2014 Regulated Electric:'
                ),
                ' Companies that generate, transmit, or distribute electric energy for sale.'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'industry-icon-bullet' },
                _react2.default.createElement(
                  'strong',
                  null,
                  'Utilities \u2014 Regulated Gas:'
                ),
                ' Companies that transmit, store, or distribute natural gas.'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'industry-icon-bullet' },
                _react2.default.createElement(
                  'strong',
                  null,
                  'Utilities \u2014 Diversified:'
                ),
                ' Companies engaged in the regulated generation, transmission, or distribution of electricity and natural gas, merchant power generation facilities, and energy marketing operations.'
              ),
              _react2.default.createElement(
                'p',
                { styleName: 'industry-icon-bullet' },
                'We remove any utilities that are engaged in 100% renewable operations, pure transmission, or otherwise don\'t distribute gas or burn fossil fuels to generate power.'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'signup-form-container' },
            _react2.default.createElement(
              'div',
              { styleName: 'signup-form-container-inner' },
              _react2.default.createElement(_components.AboutBanner, null)
            )
          )
        )
      );
    }
  }]);
  return Morningstar;
}(_react.Component)) || _class);
exports.default = Morningstar;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Morningstar/Morningstar.js
// module id = 1415
// module chunks = 0